<template>
  <div class="readQuestion-box">
    <ScrollBox>
      <div>
        <div class="readQuestion-title">
          <div class="title-left">
            <p class="china-title">{{ currentQuestionList1.tips_cnname }}</p>
            <p class="en-title">{{ currentQuestionList1.tips_enname }}</p>
          </div>
          <div class="title-right" v-if="currentQuestionList1.has_audio == 1">
            <div class="audio-add" @click="playAudio">
              <div
                class="audio-box"
                style="position: relative; z-index: 10"
              ></div>
              <audio
                class="audio commmonAudio"
                id="audioPlay"
                ref="audio"
                controls
                :src="currentQuestionList1.question_audio"
                autoplay
              ></audio>
            </div>
          </div>
        </div>
        <div class="readContent" style="margin-bottom: 20px">
          {{ currentQuestionList1.question_readtext }}
        </div>
        <div class="readStart">
          <!-- 选择 题目 -->
          <div v-for="(item, index) of readListContent1" :key="index">
            <!-- 图片选择 题目 -->
            <div class="subject-box" v-if="item.category_id == 11">
              <div class="subject-box-title">
                <div class="title-left">
                  <!-- <p class="china-title">{{item.tips_cnname}}</p> -->
                  <!-- <p class="en-title">{{item.tips_enname}}</p> -->
                  <p class="china-title">
                    第{{ index + 1 }}{{ $t("Common.subject") }}
                  </p>
                  <p class="en-title">{{ item.question_title }}</p>
                </div>
              </div>
              <div class="subject-content-box">
                <div class="subject-content">
                  <div class="word-box" v-html="item.question_title"></div>
                  <div class="img-box">
                    <div
                      class="item"
                      v-for="(item1, index1) of item.option"
                      :key="index1"
                    >
                      <!-- {{anwsersAll.answers[index].answers}} -->
                      <input
                        @change="
                          iptChange(
                            item1.question_id,
                            item1.answers_optionname,
                            index
                          )
                        "
                        type="radio"
                        :name="`one${index}`"
                        class="chooseChecked checked"
                        :id="`one${item.question_id}_${index1}`"
                        :value="item1.answers_optionname"
                        v-model="anwsersAll.answers[index].answers"
                      />
                      <label
                        :for="`one${item.question_id}_${index1}`"
                        class="label-box"
                      >
                        <div class="img">
                          <img :src="item1.answers_optionimg" alt />
                        </div>
                        <span class="option">{{
                          item1.answers_optionname
                        }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 文字选择 题目 -->
            <div class="subject-box" v-else-if="item.category_id == 12">
              <div class="subject-box-title">
                <div class="title-left">
                  <!-- <p class="china-title">{{item.tips_cnname}}</p> -->
                  <!-- <p class="en-title">{{item.tips_enname}}</p> -->
                  <p class="china-title">
                    第{{ index + 1 }}{{ $t("Common.subject") }}
                  </p>
                  <p class="en-title">{{ item.question_title }}</p>
                </div>
              </div>
              <div class="subject-content-box">
                <div class="subject-content wordSelect-type">
                  <div
                    class="word-box"
                    v-html="currentQuestionList1.question_title"
                  ></div>
                  <div class="isHasImg">
                    <img :src="currentQuestionList1.question_titleimg" alt />
                  </div>
                  <div class="wordSelect-box">
                    <div
                      class="item"
                      v-for="(item1, index1) of item.option"
                      :key="index1"
                    >
                      <!-- {{anwsersAll.answers[index].answers}} -->
                      <input
                        @change="
                          wordChange(
                            item1.question_id,
                            item1.answers_optionname,
                            index
                          )
                        "
                        type="radio"
                        :name="`word${index}`"
                        class="chooseChecked checked"
                        :id="`word${item.question_id}_${index1}`"
                        :value="item1.answers_optionname"
                        v-model="anwsersAll.answers[index].answers"
                      />
                      <label
                        :for="`word${item.question_id}_${index1}`"
                        class="label-box"
                      >
                        <div class="word-value">{{ item1.answers_option }}</div>
                        <span class="option">{{
                          item1.answers_optionname
                        }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 填空题 上下文-->
            <div class="subject-box" v-else-if="item.category_id == 15">
              <div class="subject-box-title">
                <div class="title-left">
                  <!-- <p class="china-title">{{item.tips_cnname}}</p> -->
                  <!-- <p class="en-title">{{item.tips_enname}}</p> -->
                  <p class="china-title">
                    第{{ index + 1 }}{{ $t("Common.subject") }}
                  </p>
                  <p class="en-title">{{ item.question_title }}</p>
                </div>
              </div>
              <div class="subject-content-box">
                <div class="subject-content fillBlank">
                  <div class="word-box" v-html="item.question_title"></div>
                  <div class="isHasImg" v-if="item.has_img == 1">
                    <img
                      :src="item.question_titleimg"
                      style="max-width: 300px"
                    />
                  </div>
                  <div class="fill-box">
                    <div class="item">
                      <p class="item-fill item-fill-top">
                        <span v-html="item.question_content"></span>
                        <!-- {{anwsersAll.answers[index].answers}} -->
                        <input
                          type="text"
                          class="ipt"
                          v-model="anwsersAll.answers[index].answers"
                          @change="fillText(item.question_id, index)"
                        />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 判断题 -->
            <div class="subject-box" v-else-if="item.category_id == 18">
              <div class="subject-box-title">
                <div class="title-left">
                  <!-- <p class="china-title">{{item.tips_cnname}}</p> -->
                  <!-- <p class="en-title">{{item.tips_enname}}</p> -->
                  <p class="china-title">
                    第{{ index + 1 }}{{ $t("Common.subject") }}
                  </p>
                  <p class="en-title">{{ item.question_title }}</p>
                </div>
                <div class="title-right" v-if="item.has_audio == 1">
                  <div class="audio-add" @click="playAudioInnner(index)">
                    <div
                      class="audio-box"
                      style="position: relative; z-index: 10"
                    ></div>
                    <audio
                      class="audio commmonAudio"
                      :id="`audio${index}`"
                      :ref="`audio${index}`"
                      controls
                      :src="item.question_audio"
                    ></audio>
                  </div>
                </div>
              </div>
              <div class="subject-content-box flex-align">
                <div class="subject-content judge-box">
                  <div class="word-box" v-html="item.question_title"></div>
                  <div class="isHasImg" v-if="item.has_img == 1">
                    <img
                      :src="item.question_titleimg"
                      style="max-width: 300px"
                    />
                  </div>
                  <div class="judge">
                    <div
                      class="item"
                      v-for="(item1, index1) of item.option"
                      :key="index1"
                      :class="`judgeChecked${index1 + 1}`"
                    >
                      <!-- {{anwsersAll.answers[index].answers}} -->
                      <input
                        @change="
                          judgeChange(
                            item1.question_id,
                            item1.answers_optionname,
                            index
                          )
                        "
                        type="radio"
                        :name="`judge${index}`"
                        class="judgeChecked checked"
                        :id="`judges${item.question_id}_${index1}`"
                        v-model="anwsersAll.answers[index].answers"
                        :value="item1.answers_optionname"
                      />
                      <label
                        :for="`judges${item.question_id}_${index1}`"
                        class="label-box"
                      >
                        <div class="isTrue"></div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ScrollBox>
  </div>
</template>

<script>
import evaluationStore from "@/views/StudyCenter/Evaluation/Evaluation";
// import PictureSelection from "@/components/TestQuestion/PictureSelection";
// import wordSelection from "@/components/TestQuestion/wordSelection";
// import FillBlank from "@/components/TestQuestion/FillBlank";
// import Judge from "@/components/TestQuestion/Judge";

import ScrollBox from "@/components/ScrollBox";
export default {
  name: "Read",
  components: {
    // PictureSelection, //图片选择题
    // wordSelection, //文字选选择题目
    // FillBlank, //填空题
    // Judge, //判断题
    ScrollBox,
  },
  props: {
    currentQuestionList: {
      type: Object,
    },
    //当前点击到 第几题
    currentId: {
      type: Number,
    },
    //当前题目答案格式
    anwsersAll: {
      type: Object,
    },
    //所有题目答案格式
    anwsersListAll: {
      type: Array,
    },
    readListContent: {
      type: Array,
    },
  },
  data() {
    return {
      currentQuestionList1: {},
      studentInfo: {
        token: "",
        member_id: "",
        student_id: "", //学生ID
        examine_branch: "", //检测编号
        examine_name: "", //检测名称
      },
      readList: [], //阅读题-子题目
      readListContent1: [],
      // readListContent: [], //阅读题-子题目 内容
      // propChild: {
      //   PictureSelection1: {}, //图片选择
      //   wordSelection1: {}, //文字选择
      //   FillBlank1: {}, //填空题
      //   Judge: {}, //判断题
      //   ImgClick: {}, //图片点击
      //   Sort: {}, //排序题
      //   DragType: {}, //拖拽题
      //   Connection: {}, //连线题
      // },
      picked1: "",
      picked2: "",
      question: {
        Index: -1,
        flag: false,
      },
      answerList: [
        {
          answer: [],
        },
      ],
    };
  },
  created() {
    this.studentInfo.token = this.$store.state.token;
    this.studentInfo.member_id = this.$store.state.member_id;
    this.studentInfo.student_id = this.$store.state.currentChild.student_id;
    this.studentInfo.examine_name = unescape(this.$route.query.examine_name);
    this.studentInfo.examine_branch = this.$route.query.examine_branch;
    console.log(this.anwsersAll, "我是阅读题");
    console.log(this.currentQuestionList);
    console.log(this.readListContent, "baba----------------");
    this.readListContent1 = this.readListContent;
  },
  watch: {
    getData(n, o) {
      console.log(22222);
      console.log(n, o, "我接收到的数据");
      this.currentQuestionList1 = n;
    },
    readListContentData(n, o) {
      this.readListContent1 = n;
      console.log(n, o);
    },
  },
  computed: {
    getData() {
      return this.currentQuestionList;
    },
    readListContentData() {
      return this.readListContent;
    },
  },
  // props: ['title'],
  methods: {
    //获取 测评 题目问题详情
    getQuestion(id) {
      evaluationStore
        .getQuestion({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          question_id: id,
          is_analysis: "", //	是否需要题目分析 1-需要 不传为不需要
        })
        .then((res) => {
          if (res.data.error == 0) {
            let list = res.data.result.list;
            // let categoryType = list.category_id;
            // console.log(list.category_id,'我是巴拉巴拉')
            this.readListContent.push(list);
          }
        });
    },
    //图片上传
    iptChange(id, value, index) {
      console.log(id, value, index);
      console.log(this.anwsersListAll, "所有");
      console.log(this.anwsersAll.answers, "=====阅读题答案");
    },
    //文字选择题 - 点击
    wordChange(id, value, index) {
      console.log(id, value, index);
      console.log(this.anwsersListAll, "所有");
      console.log(this.anwsersAll.answers, "=====阅读题答案");
    },
    //填空题 上下文
    fillText(id, index) {
      console.log(id, index);
      console.log(this.anwsersListAll, "所有");
      console.log(this.anwsersAll.answers, "=====阅读题答案");
    },
    //阅读题 上面大题的播放
    playAudio() {
      let audioComm = document.getElementsByClassName("commmonAudio");
      let arr = Array.prototype.slice.call(audioComm);
      for (let key in arr) {
        let isPause = arr[key];
        isPause.pause();
      }
      let audio = this.$refs.audio;
      audio.play();
    },
    //判断题 - 音频播放
    playAudioInnner(index) {
      console.log(this.anwsersListAll, "所有");

      let doms = document.getElementById(`audio${index}`);
      let audioComm = document.getElementsByClassName("commmonAudio");
      let arr = Array.prototype.slice.call(audioComm);

      for (let key in arr) {
        let isPause = arr[key];
        isPause.pause();
      }
      doms.play();
    },
    //判断题 -
    judgeChange(id, value, index) {
      console.log(id, value, index);
      console.log(this.anwsersListAll, "所有");
      console.log(this.anwsersAll.answers, "=====阅读题答案");
    },
  },
};
</script>

<style lang="less">
.readQuestion-box {
  height: calc(100% - 66px);
  .readQuestion-title {
    margin: 20px 0;
  }
  .subject-box {
    height: auto !important;
    margin-bottom: 20px;

    .subject-content-box {
      height: auto;

      .subject-content {
        .isHasImg {
          text-align: center;
        }

        width: 100%;

        .word-box {
          margin-top: 20px;
          margin-bottom: 20px;
        }

        .wordSelect-box {
          margin-top: 20px;
          justify-content: center;
        }

        .img-box {
          justify-content: center;
        }

        .judge {
          justify-content: center;
        }

        .fill-box {
          .item {
            .item-fill {
              text-align: center;
            }
          }
        }
      }
    }
  }
}

.readQuestion-box + .subject-change {
  position: static;
  transform: none;
  margin-top: 20px;
}
</style>
